import { __assign, __extends } from "tslib";
import React from 'react';
import { PnmacPaper, PnmacUIButton, PnmacRowHeader, PnmacSubheading, PnmacMediaQuery, PnmacTextInput, PnmacCard, PnmacHtmlToNative, PnmacMeta } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { ErrorMessage } from '../../components/ErrorMessage.js';
import { textStyle } from "../../v2/theme";
var UserName = /** @class */function (_super) {
  __extends(UserName, _super);
  function UserName(props) {
    var _this = _super.call(this, props) || this;
    _this.submitUserName = function () {
      var newUsereName = _this.state.newUsereName;
      var get_user_profile = _this.props.get_user_profile;
      fetch("api/account/is_username_available", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: JSON.stringify({
          userName: newUsereName,
          loanId: _this.props.layout.selectedLoanNumber
        })
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (!data) {
          fetch("api/account/update_user_name", {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(_this.props.layout.token)
            },
            body: JSON.stringify({
              userName: newUsereName,
              loanId: _this.props.layout.selectedLoanNumber
            })
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            if (data && data.user_id != null) {
              _this.setState({
                confirmFinal: true,
                laoding: false
              }, function () {
                get_user_profile();
              });
              _this.props.layout.isusernamechanged = true;
            } else {
              _this.props.layout.isusernamechanged = false;
              _this.setState({
                confirmFinal: false,
                userNameChangeNetworkError: true,
                laoding: false
              });
            }
          });
        } else {
          _this.props.layout.isusernamechanged = false;
          _this.setState({
            confirmFinal: false,
            userNameAvailableError: true,
            laoding: false
          });
        }
      });
    };
    _this.state = {
      currentUserName: "Temp User",
      newUsereName: "",
      confirmNewUsereName: "",
      confirmNewUsereNameError: false,
      newUsereNameError: false,
      confirmFinal: false,
      userNameChangeNetworkError: false,
      userNameAvailableError: false,
      laoding: false
    };
    return _this;
  }
  UserName.prototype.render = function () {
    var _this = this;
    var _a = this.state,
      newUsereName = _a.newUsereName,
      newUsereNameError = _a.newUsereNameError,
      confirmNewUsereName = _a.confirmNewUsereName,
      confirmNewUsereNameError = _a.confirmNewUsereNameError,
      userNameChangeNetworkError = _a.userNameChangeNetworkError,
      confirmFinal = _a.confirmFinal,
      userNameAvailableError = _a.userNameAvailableError;
    var _b = this.props,
      layout = _b.layout,
      translations = _b.translations;
    var validateTextInput = function () {
      var _a;
      if (newUsereName.length < 10 || newUsereName.length > 50) {
        _this.setState({
          newUsereNameError: true,
          NewUsereNameErrorMessage: translations.NewUsernameLength
        });
      } else {
        if (newUsereName.match(/^[A-Za-z0-9]*$/g)) {
          if (newUsereName.match(/^(?=.*[a-zA-Z])[A-Za-z0-9]*$/g)) {
            if (newUsereName == ((_a = layout === null || layout === void 0 ? void 0 : layout.userProfile) === null || _a === void 0 ? void 0 : _a.username)) {
              _this.setState({
                newUsereNameError: true,
                NewUsereNameErrorMessage: "Must be different from current user name"
              });
            } else if (newUsereName != confirmNewUsereName) {
              _this.setState({
                newUsereNameError: false
              });
              _this.setState({
                confirmNewUsereNameError: true
              });
            } else {
              _this.setState({
                newUsereNameError: false
              });
              _this.setState({
                confirmNewUsereNameError: false
              });
            }
          } else {
            _this.setState({
              newUsereNameError: true,
              NewUsereNameErrorMessage: "Must contain at least one letter"
            });
          }
        } else {
          _this.setState({
            newUsereNameError: true,
            NewUsereNameErrorMessage: "Must not contain special characters, such as: ! @ # $ -"
          });
        }
      }
    };
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "User Name"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false,
            laoding: false
          });
        },
        message: translations.UsernameSuccessMessage
      }) : userNameChangeNetworkError ? /*#__PURE__*/React.createElement(ErrorMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false,
            userNameChangeNetworkError: false,
            laoding: false
          });
        },
        message: translations.UserNameChangeErrorMessage
      }) : userNameAvailableError ? /*#__PURE__*/React.createElement(ErrorMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false,
            userNameAvailableError: false,
            laoding: false
          });
        },
        message: translations.userNameAvailableError
      }) : null, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: styles.accountSettings.titleContainer,
        item: translations.UserName
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          cursor: "default",
          backgroundColor: "#FFF",
          padding: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          borderBottom: "1px solid #e9e9e9",
          display: "flex",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1,
          height: 300
        },
        onPress: validateTextInput
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flex: 3,
          flexDirection: "column",
          alignItems: 'flex-start'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          width: '100%',
          flexDirection: "row",
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          fontSize: matches.small ? 14 : 16
        })
      }, translations.CurrentUserName)), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/React.createElement("div", {
        idTag1: 'txtUsereName',
        style: __assign({}, textStyle.defaultTextTitle)
      }, (_a = layout === null || layout === void 0 ? void 0 : layout.userProfile) === null || _a === void 0 ? void 0 : _a.username))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          width: '100%',
          flexDirection: "row",
          alignItems: 'center',
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          fontSize: matches.small ? 14 : 16
        })
      }, translations.NewUserName)), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 400
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "New User Name",
        nativeID: "lblNewUserName",
        idTag1: 'txtNewUsereName',
        mode: "outlined",
        label: newUsereNameError ? _this.state.NewUsereNameErrorMessage : translations.NewUserName,
        value: newUsereName,
        disabled: confirmFinal || _this.props.layout.isusernamechanged,
        error: newUsereNameError,
        onChangeText: function (newUsereName) {
          return _this.setState({
            newUsereName: newUsereName
          });
        },
        onBlur: validateTextInput
      })))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          width: '100%',
          flexDirection: "row",
          alignItems: 'center',
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          fontSize: matches.small ? 14 : 16
        })
      }, translations.ConfirmNewUserName)), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 400
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Confirm New User Name",
        nativeID: "lblConfirmNewUserName",
        idTag1: 'txtConfirmNewUsereName',
        mode: "outlined",
        label: confirmNewUsereNameError ? translations.AttrNewUserValidationMessage : translations.ConfirmNewUserName,
        value: confirmNewUsereName,
        disabled: confirmFinal || _this.props.layout.isusernamechanged,
        error: confirmNewUsereNameError,
        style: {
          marginBottom: 12
        },
        onChangeText: function (confirmNewUsereName) {
          return _this.setState({
            confirmNewUsereName: confirmNewUsereName
          });
        },
        onBlur: validateTextInput
      }))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flex: 2,
          flexDirection: "column",
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "usernameGuidelines",
        style: {
          flex: 1,
          backgroundColor: '#EDFAFF',
          paddingHorizontal: 10,
          paddingVertical: 10,
          margin: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        value: translations.UserNameGuideLines
      }))))), /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, styles.accountSettings.buttonContainer), {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          height: "inherit"
        })
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnUsernameChange',
        loading: _this.state.laoding,
        disabled: confirmNewUsereNameError || newUsereNameError || newUsereName == "" || confirmNewUsereName == "" || newUsereName == confirmNewUsereName && newUsereName == ((_b = layout === null || layout === void 0 ? void 0 : layout.userProfile) === null || _b === void 0 ? void 0 : _b.username) || _this.props.layout.isusernamechanged || userNameAvailableError,
        onClick: function () {
          var _a;
          if (!(confirmNewUsereNameError || newUsereNameError || newUsereName == "" || confirmNewUsereName == "" || newUsereName == confirmNewUsereName && newUsereName == ((_a = layout === null || layout === void 0 ? void 0 : layout.userProfile) === null || _a === void 0 ? void 0 : _a.username) || _this.props.layout.isusernamechanged || userNameAvailableError)) {
            _this.setState({
              laoding: true
            }, function () {
              return _this.submitUserName();
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Username Change Button Clicked", 262);
          }
        }
      }, translations.Change)))));
    });
  };
  return UserName;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(UserName);